import PropTypes from 'prop-types';

// components
import { HoverRoom } from 'dibs-zoom-modal/exports/HoverRoom';

// styles
import styles from './PdpRespHeroCarouselViewInRoom.scss';

export const PdpRespHeroCarouselViewInRoom = props => {
    const { onClick, roomViewItem, room } = props;

    return (
        <div className={styles.container} onClick={onClick}>
            <HoverRoom item={roomViewItem} room={room} />
        </div>
    );
};

PdpRespHeroCarouselViewInRoom.defaultProps = {
    onClick: () => {},
};

PdpRespHeroCarouselViewInRoom.propTypes = {
    room: PropTypes.object,
    onClick: PropTypes.func,
    roomViewItem: PropTypes.object,
};
